module.exports = __webpack_public_path__ + "img/logo.b0f5d63e.png";